import { close, toggle } from "./toggle";

type Inputs = {
  toggleElement: HTMLElement;
  menuElement: HTMLElement;
};

export function initInfoPopup({ toggleElement, menuElement }: Inputs): void {
  toggleElement.addEventListener("click", (e) => {
    e.stopPropagation();
    toggle(menuElement);
  });

  document.addEventListener("click", (e) => {
    const target = e.target as Node;
    if (!toggleElement.contains(target) && !menuElement.contains(target)) {
      close(menuElement);
    }
  });
}
